var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#476F2A;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.1,353.2h12.2c8,0,11.5,4.7,11.5,11c0,7.3-4.9,10.7-12.1,10.7h-5.1v11.3h-6.5V353.2z M180,369.2 c4.1,0,6-2,6-5.1c0-3.1-2-5.1-5.7-5.1h-4.7v10.1H180z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.3,353.2h6.7v33h-6.7V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.3,353.2h6.4l14.8,22.3h0.1v-22.3h6.5v33h-6.6l-14.7-21.8h-0.1v21.8h-6.5V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.3,353.2h21.1v5.8h-14.7v8h11.7v5.7h-11.7v7.7h15.6v5.8h-22.1V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.2,353.2h6.4l14.8,22.3h0.1v-22.3h6.5v33h-6.6l-14.7-21.8h-0.1v21.8h-6.5V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.2,353.2h21.1v5.8h-14.7v8h11.7v5.7h-11.7v7.7h15.6v5.8h-22.1V353.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250,98.9c-54.3,0-98.3,44-98.3,98.3s44,98.3,98.3,98.3s98.3-44,98.3-98.3S304.3,98.9,250,98.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210.5,145.1c3.6,0,6.7,1.2,9.3,3.7c2.6,2.4,3.9,6,3.9,10.8v34.1c0,4.5-1.2,7.6-3.7,9.5 c-2.4,1.8-5.4,2.8-9,2.8h-6.4v43.4h-10.1V145.1H210.5z M213.7,161.1c0-2.6-0.4-4.5-1.2-5.7c-0.8-1.2-1.8-1.8-3-1.8h-4.8v44h5.4 c2.4,0,3.6-2.3,3.6-7V161.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258.4,249.3l-13.6-73.2h-0.1v73.2h-8.5V145.1h11.5l12.8,72.1v-72.1h9.4v104.2H258.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.4,153.6v39.8h10.3v7.6h-10.3v39.8h14v8.5h-24.1V145.1h23.4v8.5H291.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinene);
export default __webpack_public_path__ + "static/media/PINENE.4692d8a03df5a7368d611af1c3dbeb11.svg";
export { ForwardRef as ReactComponent };